import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { NOOP_VALUE_ACCESSOR } from '../../constants/noop-value-accessor.const';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  viewProviders: [
    {
      // Serves the parent form control
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormInputComponent {
  @Input('color') color: ThemePalette = 'primary';
  @Input('text') text: string = 'Placeholder Text';
  @Input('name') name: string;
  @Input('type') type: string;
  @Input('formControlName') formControlName: string | null;
  @Input('uppercase') uppercase: boolean = false;
  @Input('disabled') disabled: boolean = false;
  @Input('outlined') outlined: MatFormFieldAppearance = 'outline';
  @Input('hintText') hintText: string = '';
  @Input('errorMsg') errorMsg: string = '';
  @Input('width') width: string = '328px';
  @Input('maxWidth') maxWidth: string = '100%';
  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
    }
  }
}
